import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M4.352 7.982l2.35 2.182 4.95-4.5" stroke="currentcolor"/><circle stroke="currentcolor" transform="translate(8 8)" r="7"/></svg>`;

export { symbol as default };
